export const SUBSIDY_WITH_INCOME_URLS = {
  GET_ALL_WITH_INCOME_CONFIGURATION: '/configurations',
  CREATE_WITH_INCOME_CONFIGURATION: '/configurations',
  UPDATE_WITH_INCOME_CONFIGURATION: '/configurations',
  GET_ALL_APPLICATION_TYPE_REQUEST: '/application/request',
  GET_SINGLE_WITH_INCOME_CONFIGURATION: '/configurations/getConfiguration',
  DELETE_WITH_INCOME_CONFIGURATION: '/configurations'
};
